import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/landing.css';

/**
 * Placeholder Terms of Service — not legal advice; content to be finalized.
 */
const Terms: React.FC = () => {
  return (
    <div className="landing-legal">
      <a href="#legal-main" className="landing-skip">
        Skip to main content
      </a>
      <header className="landing-legal__header">
        <Link to="/" className="landing-brand">
          <span className="landing-brand__mark" aria-hidden="true">
            <svg viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
              <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zm0 10a2 2 0 11-.001-3.999A2 2 0 0110 12z" />
            </svg>
          </span>
          <span className="landing-brand__text">Winery</span>
        </Link>
        <Link to="/login" className="landing-btn landing-btn--primary landing-btn--sm">
          Sign in
        </Link>
      </header>

      <main id="legal-main" className="landing-legal__main">
        <p className="landing-legal__banner" role="note">
          This page is a placeholder summary and is not legal advice. Final terms will be published
          before production use. Governing law and venue are to be determined. Last updated: July
          11, 2026.
        </p>

        <h1>Terms of Service</h1>
        <p>
          By accessing or using Wine Management System (the “Service”), you agree to these
          placeholder terms on behalf of yourself and, where applicable, the winery organization
          that invited you.
        </p>

        <h2>The Service</h2>
        <p>
          The Service provides software tools for winery production operations (including vineyard,
          batch, fermentation, aging, bottling, inventory, vessels, and related features). It is
          intended for licensed business / winery use. It is not a consumer marketplace, tasting
          journal, or source of legal or regulatory advice.
        </p>

        <h2>Accounts and acceptable use</h2>
        <p>
          You must keep credentials confidential and use the Service only as authorized by your
          organization. You may not misuse the Service, attempt unauthorized access, interfere with
          other users, or use the Service in violation of applicable law.
        </p>

        <h2>Your data</h2>
        <p>
          Your organization remains responsible for the accuracy and legality of operational data
          entered into the Service. You grant us a limited license to host and process that data
          solely to provide the Service.
        </p>

        <h2>Disclaimer of warranties</h2>
        <p>
          The Service is provided “as is” and “as available” without warranties of any kind,
          express or implied, to the fullest extent permitted by law — including merchantability,
          fitness for a particular purpose, and non-infringement.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, we are not liable for indirect, incidental,
          special, consequential, or punitive damages, or for lost profits, data, or production
          outcomes arising from use of the Service. Our aggregate liability for claims relating to
          the Service is limited to the amounts paid for the Service in the twelve months before
          the claim (or zero if no fees were paid).
        </p>

        <h2>Governing law</h2>
        <p>
          Governing law and dispute venue will be specified in the final Terms. Until then, these
          placeholders do not create a binding choice of law.
        </p>

        <h2>Contact</h2>
        <p>
          Contact details for contractual notices will be listed here when available.
        </p>

        <p>
          <Link to="/">Back to home</Link>
          {' · '}
          <Link to="/privacy">Privacy Policy</Link>
        </p>
      </main>
    </div>
  );
};

export default Terms;
